export default "__VITE_ASSET__175b2bf5__"